/**
 * Pantalla de login.  (FR-037 · FR-005 · spec 040)
 *
 * Sin pre-relleno: la contraseña la sabe quien entra, no el JS ni la API.
 */
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router'

import { CLAVE_SESION, type Sesion } from '../auth'
import { Button } from '../components/ui/button'
import { Input } from '../components/ui/input'
import { api, ErrorApi } from '../lib/api'
import { destinoTrasLogin } from '../lib/raiz-por-rol'

export function Login() {
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState<string | null>(null)
    const [enviando, setEnviando] = useState(false)

    async function entrar(e: React.FormEvent) {
        e.preventDefault()
        setError(null)
        setEnviando(true)
        try {
            await api.post('/auth/login', { email, password })
            await queryClient.invalidateQueries({ queryKey: CLAVE_SESION })
            const sesion = await queryClient.fetchQuery({
                queryKey: CLAVE_SESION,
                queryFn: () => api.get<Sesion>('/auth/me'),
            })
            navigate(destinoTrasLogin(sesion) ?? '/', { replace: true })
        } catch (err) {
            setError(err instanceof ErrorApi && err.status === 401 ? 'Credenciales inválidas' : 'No se pudo entrar')
        } finally {
            setEnviando(false)
        }
    }

    return (
        <div className="grid min-h-screen place-items-center bg-neutral-950 font-sans text-neutral-200">
            <form onSubmit={(e) => void entrar(e)} className="mx-4 w-full max-w-96 space-y-5 rounded-xl border border-neutral-800 bg-neutral-900 p-8">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight text-neutral-100">Agendify</h1>
                    <p className="mt-1 text-sm text-neutral-500">Panel de operación</p>
                </div>
                <div className="space-y-2">
                    <Input
                        aria-label="Correo"
                        placeholder="correo"
                        type="email"
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <Input
                        aria-label="Contraseña"
                        type="password"
                        placeholder="contraseña"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                {error && (
                    <p role="alert" className="text-xs text-red-400 light:text-red-700">
                        {error}
                    </p>
                )}
                <Button type="submit" className="w-full" disabled={enviando}>
                    {enviando ? 'Entrando…' : 'Entrar'}
                </Button>
                <Link to="/forgot-password" className="block text-center text-xs text-neutral-500 hover:text-neutral-300">
                    Olvidé mi contraseña
                </Link>
            </form>
        </div>
    )
}
